<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>
    {{ 'demo.reserveDemotime' | translate }}
  </div>
  @if (willEnter()) {
    <p>{{ 'demo.reserveInfo' | translate }}</p>
    <ion-item lines="none">
      <ion-label>{{ 'demo.selectTime' | translate }}</ion-label>
      <ion-datetime-button datetime="datetime"></ion-datetime-button>
    </ion-item>
  }
  <div class="ion-margin-top">
    <ion-button color="light"
      (click)="reserve()">
      {{ 'demo.reserve' | translate }}
    </ion-button>
  </div>
</app-main-dialog>
<ion-modal [keepContentsMounted]="true">
  <ng-template>
    <ion-datetime id="datetime"
      locale="fi-FI"
      [min]="minDate"
      hourValues="10,11,12,13,14,15"
      minuteValues="0,15,30,45"
      [value]="value"
      [isDateEnabled]="isWeekday"
      [showDefaultButtons]="true"
      [doneText]="'general.done' | translate"
      [cancelText]="'general.cancel' | translate"
      (ionChange)="onChange($event)"></ion-datetime>
  </ng-template>
</ion-modal>